import * as React from 'react';

import { Typography } from '@coursera/cds-core';
import { Box, StyleSheet, css } from '@coursera/coursera-ui';

import type { InformationCardProps } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import InformationCard from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCard';
import InformationCardBody from 'bundles/enterprise-legacy-learner-home/components/InformationCard/InformationCardBody';
import { TabCaption } from 'bundles/enterprise-legacy-learner-home/components/InformationCard/typography';

import _t from 'i18n!nls/program-skills-objectives';

type HowDoLearningProgramsWorkInformationCardProps = InformationCardProps;

//
// this is like a tab card but with only one tab which the tab list layout
// doesn't support. FWIW, if we need this kind of card more, we should add a
// case to the TabListInformationCard for where there is only one tab child.
//
const styles = StyleSheet.create({
  root: {
    padding: '24px 14px',
  },

  column: {
    flex: '0 1 50%',

    ':nth-child(n) > div:nth-child(n+2)': {
      marginLeft: '1.25rem',
    },
  },
  paragraph: {
    marginBottom: '10px',
  },
});

const HowDoLearningProgramsWorkInformationCard: React.FC<HowDoLearningProgramsWorkInformationCardProps> = (props) => (
  <InformationCard {...props} rootClassName={css(styles.root, props.rootClassName).className}>
    <InformationCardBody>
      <TabCaption>{_t('How do Learning Programs work?')}</TabCaption>

      <Box rootClassName={styles.column}>
        <div {...css(styles.column)}>
          <Typography {...css(styles.paragraph)}>
            {_t(
              'A Learning Program is a place where a group of invited learners have access to a catalog of courses that help them develop relevant skills that will help them perform in their current job and accomplish their future career goals.'
            )}
          </Typography>
          <Typography {...css(styles.paragraph)}>
            {_t(
              'Learners must be invited to join a Learning Program and a learner can join multiple Learning Programs.'
            )}
          </Typography>
        </div>
        <div {...css(styles.column)}>
          <Typography {...css(styles.paragraph)}>
            {_t(
              'Each Learning Program has a dedicated catalog of courses that only learners invited to join that program can access.'
            )}
          </Typography>
          <Typography {...css(styles.paragraph)}>
            {_t(
              'Program Admins can edit the catalog of course recommendations and add curated collections of courses. They can also invite, remove and view reports for the learners of that Learning Program.'
            )}
          </Typography>
        </div>
      </Box>
    </InformationCardBody>
  </InformationCard>
);

export default HowDoLearningProgramsWorkInformationCard;
